import { render, staticRenderFns } from "./joinChargeDialog.vue?vue&type=template&id=3659d9f4&"
import script from "./joinChargeDialog.vue?vue&type=script&lang=js&"
export * from "./joinChargeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3659d9f4')) {
      api.createRecord('3659d9f4', component.options)
    } else {
      api.reload('3659d9f4', component.options)
    }
    module.hot.accept("./joinChargeDialog.vue?vue&type=template&id=3659d9f4&", function () {
      api.rerender('3659d9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Act/joinChargeDialog.vue"
export default component.exports